const ITEMS = [
  "BEST NEWCOMER 2026 FINALIST — NEWTON ABBOT AWARDS",
  "GAS SAFE REGISTERED #951592",
  "24/7 EMERGENCY BREAKDOWN",
  "WORCESTER BOSCH INSTALLERS",
  "12-MONTH PARTS GUARANTEE",
  "FIXED PRICES — NO HIDDEN FEES",
  "TEIGNBRIDGE & SOUTH DEVON",
  "YOUR LOCAL PLUMBER & HEATING ENGINEER",
  "EXETER · TORBAY · TEIGNBRIDGE · SOUTH DEVON & SURROUNDING AREAS",
  "NEW BOILERS FROM £1,799 FULLY FITTED",
  "GENERAL PLUMBING — TOILETS, BASINS, SINKS & TAPS",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="border-y border-white/10 bg-[#0E0E0E] py-4 overflow-hidden select-none">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="font-mono text-xs tracking-[0.3em] text-neutral-500 uppercase flex items-center">
            <span className="px-6">{item}</span>
            <span className="text-torch">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};
